import React, { Component } from 'react';

import { bemClasses } from '../../../utils/bem';

import './styles.scss';

class Input extends Component {
  constructor() {
    super();

    this.state = {
      value: '',
    };
  }

  componentWillMount = () => {
    this.setState({ value: this.props.value });
  };

  componentDidMount = () => {
    if (this.props.autoFocus) {
      this.refs.input.focus();
    }
  };

  componentDidUpdate = prevProps => {
    if (this.props.value !== prevProps.value) {
      this.setState({ value: this.props.value });
    }
  };

  ALLOWED_MODIFIERS = ['grey-box', 'withAttachedButton', 'disabled'];

  componentClassNames = () => {
    return bemClasses('input', this.ALLOWED_MODIFIERS, this.props);
  };

  onChange = event => {
    let value = event.target.value;

    this.setState({ value: value });

    if (this.props.onChange) {
      this.props.onChange(value);
    }
  };

  inputProps = () => {
    return {
      accept: this.props.accept,
      autoFocus: this.props.autoFocus,
      className: this.componentClassNames(),
      disabled: this.props.disabled,
      max: this.props.max,
      min: this.props.min,
      minLength: this.props.minLength,
      maxLength: this.props.maxLength,
      name: this.props.name,
      onChange: this.onChange,
      placeholder: this.props.placeholder,
      required: this.props.required,
      type: this.props.type,
      value: this.state.value,
      pattern: this.props.pattern,
      title: this.props.title,
    };
  };

  renderInput = () => {
    if (this.props.lines > 1) {
      return (
        <textarea
          ref={'input'}
          key={'input'}
          {...this.inputProps()}
          rows={this.props.lines}
        />
      );
    } else {
      return <input ref={'input'} key={'input'} {...this.inputProps()} />;
    }
  };

  render = () => {
    return this.renderInput();
  };
}

export default Input;
